import { call, put, takeEvery } from 'redux-saga/effects';

import {
    FETCH_DEMOGRAPHIC_COMPARE,
    FETCH_DEMOGRAPHIC_COMPARE_FETCHING,
    FETCH_DEMOGRAPHIC_COMPARE_SUCCESS,
    FETCH_DEMOGRAPHIC_COMPARE_FAIL
} from '../actions/ActionTypes';
import { insightsApi } from 'config/axios';

// Worker
export function* fetchDemographicCompareSaga(action) {
    // month is an optional parameter
    const { gender, age, activityType, field, lang, measurementSystem, year, month } = action;
    let newAge = age;

    try {
        yield put({
            type: FETCH_DEMOGRAPHIC_COMPARE_FETCHING,
            activityType: activityType,
            data: {}
        });

        // Remove the '+' sign from any values that might be '75+' otherwise the call returns a 400 error
        if (age.includes('+')) {
            newAge = age.replace('+', '');
        }

        const response = yield call(
            insightsApi.get,
            `/gcs-insights/api/demographics/compare?gender=${gender}&age=${newAge}&type=${activityType}&field=${field}&lang=${lang}&localeUnit=${measurementSystem}&year=${year}${
                month ? `&month=${month}` : ''
            }`
        );

        yield put({
            type: FETCH_DEMOGRAPHIC_COMPARE_SUCCESS,
            activityType: activityType,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_DEMOGRAPHIC_COMPARE_FAIL,
            activityType: activityType,
            data: {}
        });
    }
}

// Watcher
export const demographicCompareSagas = [takeEvery(FETCH_DEMOGRAPHIC_COMPARE, fetchDemographicCompareSaga)];
